type FieldsConfigType = {
  id: number;
  name: "APA" | "MLA" | "Chicago";
  fields: {
    name:
      | "title"
      | "institution"
      | "course"
      | "runningHead"
      | "firstName"
      | "lastName"
      | "date"
      | "instructor"
      | "abstract";
    placeholder?: string;
    maxLength?: number;
    type?: string;
  }[];
}[];

export const fieldsConfig: FieldsConfigType = [
  {
    id: 1,
    name: "APA",
    fields: [
      {
        name: "title",
        placeholder: "Title",
        maxLength: 200,
      },
      {
        name: "runningHead",
        placeholder: "Running head",
        maxLength: 50,
      },
      {
        name: "institution",
        placeholder: "Institution",
      },
      {
        name: "course",
        placeholder: "Course",
      },
      {
        name: "firstName",
        placeholder: "Student’s first name",
        maxLength: 50,
      },
      {
        name: "lastName",
        placeholder: "Student’s last name",
        maxLength: 50,
      },
      {
        name: "instructor",
        placeholder: "Instructor",
        maxLength: 50,
      },
      {
        name: "date",
        type: "calendar",
        placeholder: "Deadline",
      },
    ],
  },
  {
    id: 2,
    name: "MLA",
    fields: [
      {
        name: "title",
        placeholder: "Title",
        maxLength: 200,
      },

      {
        name: "instructor",
        placeholder: "Instructor",
      },

      {
        name: "firstName",
        placeholder: "Student’s first name",
        maxLength: 50,
      },
      {
        name: "lastName",
        placeholder: "Student’s last name",
        maxLength: 50,
      },
      {
        name: "course",
        placeholder: "Course",
      },
      {
        name: "date",
        type: "calendar",
        placeholder: "Deadline",
      },
      {
        name: "abstract",
        type: "textarea",
        placeholder: "Abstract",
      },
    ],
  },
  {
    id: 3,
    name: "Chicago",
    fields: [
      {
        name: "title",
        placeholder: "Title",
        maxLength: 200,
      },
      {
        name: "course",
        placeholder: "Course",
      },
      {
        name: "firstName",
        placeholder: "Student’s first name",
        maxLength: 50,
      },
      {
        name: "lastName",
        placeholder: "Student’s last name",
        maxLength: 50,
      },
      {
        name: "date",
        type: "calendar",
        placeholder: "Deadline",
      },
    ],
  },
];
